import {Box, Center, Flex, Image, SimpleGrid, Text} from '@chakra-ui/react'
import Volume from '@assets/svgs/learn/volume_1.svg'
import CheckIcon from '@assets/svgs/learn/check_2.svg'
import {useRef} from 'react'

const Content = ({vocabulariesOverview}: {vocabulariesOverview: any}) => {
  const audioRef = useRef<any>()

  const handlePlayAudio = (file: any) => {
    audioRef.current?.pause()
    audioRef.current = new Audio(file)
    audioRef.current.play()
  }

  return (
    <Box>
      <Box
        className="scroll-bar container-xl"
        overflow={'auto'}
        mt={'-80px'}
        mb={'30px'}
        bg={'white'}
        h={'100%'}
        p={{base: '16px', md: '32px'}}
        maxH={{base: 'unset', md: '550px'}}
        minH={'300px'}
        borderRadius={'20px'}>
        <Text
          fontSize={'18px'}
          textTransform={'uppercase'}
          align={'center'}
          color={'#546E7A'}>
          nội dung học
        </Text>
        <Flex mt={'24px'} flexDirection={{base: 'column', md: 'row'}}>
          {vocabulariesOverview?.vocabularies?.map(
            (group: any, index: number) => (
              <Box
                key={index}
                w={'100%'}
                borderBottom={
                  index === vocabulariesOverview?.vocabularies?.length - 1
                    ? 'none'
                    : '1px solid #E0E0E0'
                }
                pb={'24px'}
                mb={
                  index === vocabulariesOverview?.vocabularies?.length - 1
                    ? '0px'
                    : '24px'
                }>
                <Text fontSize={'16px'} fontWeight={600} color={'#546E7A'}>
                  {group?.group_name}
                </Text>
                <SimpleGrid
                  columns={2}
                  spacing={{base: '16px', md: '30px'}}
                  pt={'24px'}>
                  {group?.vocabularies.map((item: any, index: any) => (
                    <Flex
                      key={index}
                      borderRadius={'16px'}
                      alignItems={'center'}
                      gap={'8px'}>
                      <Flex flex={1} gap={'16px'}>
                        <Image
                          src={Volume}
                          w={{base: '20px', md: '24px'}}
                          cursor={'pointer'}
                          onClick={() => handlePlayAudio(item.audio)}
                        />
                        <Box>
                          <Text
                            fontSize={{base: '14px', md: '16px'}}
                            fontWeight={600}
                            color={'#1F1F1F'}>
                            {item.text_en}
                          </Text>
                          <Text
                            fontSize={{base: '14px', md: '16px'}}
                            color={'#8C8C8C'}>
                            {item.text_vi}
                          </Text>
                        </Box>
                      </Flex>
                      {item.is_completed && (
                        <Center
                          w={{base: '20px', md: '24px'}}
                          h={{base: '20px', md: '24px'}}
                          borderRadius={'50%'}
                          bg={'#34C659'}
                          border={'1px solid #06AE70'}>
                          <Image
                            src={CheckIcon}
                            w={{base: '14px', md: '16px'}}
                          />
                        </Center>
                      )}
                    </Flex>
                  ))}
                </SimpleGrid>
              </Box>
            ),
          )}
        </Flex>
      </Box>
    </Box>
  )
}

export default Content
